import React, { useState, useEffect, useMemo } from 'react';

import {  useDispatch } from 'react-redux';

import { useHistory } from 'react-router-dom';

import {
    TextField,
    Typography,
    MenuItem,
    InputAdornment,
    Tooltip
} from '@material-ui/core';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import Swal from 'sweetalert2';

    
import '../../styles/style.scss';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";

import PaymentService from '../../services/payment.service';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import PaymentModal from './PaymentModal';
import {SET_CLIENT_DATA} from "../../actions/type";
import { bankFactory } from '../../constants/customComponent/bankFactory';
import generateReference from '../../constants/models/generateReference';
import errorHandler from '../utils/errorHandler';

import useGetCustomers from '../../constants/customComponent/useGetCustomers';
import paymentService from '../../services/payment.service';

const swalCustomButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn custom-confirm-cancel-btn',
      cancelButton: 'btn custom-cancel-btn me-3'
    },
    buttonsStyling: false
  });
  export const AdvancePaymentScreen = () => {
    const bancos = ["BBVA", "Bajio"]
    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();

    const dispatch = useDispatch();
    const history = useHistory();
    
  const location = useLocation();


    const [storedClass, setStoredClass] = useState(null)
    const [userCanPayWithBank,setCanUserPayWithBank] = useState(false)
    const [pendingPayment, setPendingPayment] = useState({
        isLoading: false,
        status: true
      });
    const [cashPayment, setCashPayment] = useState({
        isLoading:false,
        status:true
    })
    const [contentConcepts, setContentConcepts] = useState(['']);
    const [selectConcept, setSelectConcept] = useState("")
    const [ isDisabled, setIsDisabled] = useState(true);
    const [isLoadingCanPay, setIsLoadingCanPay] = useState(true)
    const [ isLoadingConceptsData, setIsLoadingConceptsData ] = useState(true);
    const [openModalPayment, setOpenModalPayment] = useState(false)
    const {customers} = useGetCustomers();
    const [ isLoadingStartAdvancePayment, setIsLoadingStartAdvancePayment ] = useState(false);
    const [dataStartPayment, setDataStartPayment] = useState({})

    const validationSchema = Yup.object().shape({
        an8: Yup.string().required('cliente requerido'),
        concept: Yup.string().required('El concepto es requerido.'),
        amount: Yup.number()
                    .typeError("Solo se admiten números.")
                    .required('El importe es requerido.'),
        comment: Yup.string().required('El comentario es requerido.')
                    .max(39, 'Máximo 39 caracteres.')
                    .matches(/^[A-zÀ-ú\d\-_\s]+$/i, "Solo se admiten letras y números."),
        banco: Yup.string()
                .required('Selecciona un banco.')  
                .oneOf(['BBVA', 'Bajio'], 'Seleccione un banco válido.') 
    });

    const {
        register,
        handleSubmit,
        getValues,
        watch,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });
    const an8 = watch("an8")
    useEffect(()=>{
        setValue("concept", "")
    },[an8,setValue])
    useEffect(() => {
        PaymentService.getConcepts().then((response)=>{
            setContentConcepts(response);
            setIsDisabled(false);
            setIsLoadingConceptsData(false);
        }).catch((error)=>{
            setContentConcepts([]);
            setIsDisabled(false);
            setIsLoadingConceptsData(false);
            if(sessionDifference > Number(tokenExpired)){
                sesionExpired(dispatch, history);
              } else{
                  actionErrorConnection(error, 
                      ( error?.response?.data) ?'No existen Conceptos de pago':'Error al recuperar concepto de pago');
              }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);


    useEffect(() => {
        const customerActived = location.state?.customer;
        
        if(customerActived){
            setValue("an8", customerActived)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    
    
  /**
   * Realiza busqueda de pago pendiente al seleccionar un an8
   * @param {object} data - estado del selector an8
   * @author alSanchez - ETE
   * @version 1.0.0 - Dociembre 2023
   */

  const onCustomerChange = (data) =>{
    if (data.target.value || (Number(data.target.value.length) !== 0)) {
        paymentService.canUserPayWithBank(data.target.value).then((response)=>{
            setIsLoadingCanPay(false)
            setCanUserPayWithBank(response)
            console.log("response", response, data.target.value)
        })
        getPendingPayment(data.target.value);
        getCashPayment(data.target.value)
    }
  }

  /**
   * Recupera estado de pago pendiente por an8
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Dociembre 2023
   */
  const getCashPayment = (an8) =>{
      //Asignando el valor de isLoading como true, inicializando el proceso de obtener el servicio 
    setCashPayment({
        isLoading: true,
        status:false
    })
    PaymentService.getstatusCashPayment(an8).then((response)=>{
        setCashPayment({
            isLoading: false,
            status:response
        })

    }).catch((error)=>{
        setPendingPayment({
            isLoading: false,
            status: false
          });  
      if(sessionDifference > Number(tokenExpired)){
        sesionExpired(dispatch, history);
      } else{
        actionErrorConnection(error, 'Error al recuperar estado de pagos pendientes.');
      }
    });
  }
  
  const getPendingPayment = (an8) =>{

    setPendingPayment({
      isLoading: true,
      status: false
    })

    PaymentService.getstatusPendingPayment(an8).then((response)=>{
        setPendingPayment({
            isLoading: false,
            status: response
          })
          
    }).catch((error)=>{
        setPendingPayment({
            isLoading: false,
            status: false
          });
      if(sessionDifference > Number(tokenExpired)){
        sesionExpired(dispatch, history);
      } else{
        actionErrorConnection(error, 'Error al recuperar estado de pagos pendientes.');
      }
    });
  }

    const startServicePaiment = async (data, e) => {
        e.preventDefault();
        try{
        setIsLoadingStartAdvancePayment(true);

        const reference = generateReference(0,selectConcept )
        const banco =getValues().banco
        const bank = bankFactory(banco)        
        const an8Select = getValues().an8;
        const clientName = customers.data?.find(({noCustomer})=>noCustomer === an8Select)?.name;
        const amount = data ? data.amount : 0.00;
        const advancePaymentArray = {
            amount: data ? data.amount : 0,
            comment: data ? data.comment : '',
            paymentConcept: data ? bank.concept[selectConcept] : '',
            transaction: reference,
            bankName:bank?.name
        };
        const clientData = {
            an8: an8Select,
            clientName: clientName,
            amount: amount,
            reference: reference,
            paymentConcept: bank.concept[selectConcept]

        }
        setDataStartPayment(advancePaymentArray); // cancelar payment cerrar modal
        dispatch({type:SET_CLIENT_DATA, payload:clientData});
        const response =  await bank?.startAdvancePayment(advancePaymentArray, an8Select)
        if(response.success){ 
            setOpenModalPayment(true)
            setStoredClass(bank)
            setIsLoadingStartAdvancePayment(false);
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text:  'Error al procesar la solicitud.',
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
              })
            }

        }catch(error){
            errorHandler(error, "Error al procesar la solicitud", history, dispatch)
        }finally{
            setIsLoadingStartAdvancePayment(false);
        }
    }

    const handleChange = (e)=>{
        let selectValue = e.target.value.split(" ").pop(); //Obtiene el nombre del metodo de pago
        
        if(selectValue === "Contado"){
            setValue("concept", e.target.value)
            if(!cashPayment.status){
                swalCustomButtons.fire({
                    title: 'Advertencia',
                    html: `<span>El cliente ${getValues().an8} no puede realizar pagos de contado </span>`,
                    icon: 'warning',
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                  });
              }
        }
        if(selectValue === "Anticipo") {
           setValue("concept", e.target.value)
            if(!pendingPayment.status){
                swalCustomButtons.fire({
                    title: 'Advertencia',
                    html: `<span>El cliente ${getValues().an8} no puede generar anticipos, cuenta con facturas pendientes </span>`,
                    icon: 'warning',
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                  });
              }
        
        }

        setSelectConcept(selectValue)
    }

    const tooltipMessage = useMemo(() => {
        if (selectConcept === "Contado" && !cashPayment.status ) {
            return "El cliente no puede realizar pago de contado";
        } else if (selectConcept === "Anticipo" && !pendingPayment.status) {
            return "El cliente no puede realizar anticipos";
        } else {
            return "";
        }
    }, [selectConcept, pendingPayment.status, cashPayment.status]);
    return (
        <>
            <div className="container-fluid p-0 m-0">
                <div className="row flex-nowrap p-0 m-0">
                    <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                        <SidebarMenu/>
                    </div>
                    <div className="col p-0 ms-1 me-1">
                        <NavTopMenu />
                        <div className="container ps-3 pe-3 container-size">
                            <div className="row base-container ">
                                <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                                    <span>Contenido </span>
                                    <i className="fas fa-angle-right ms-2 me-2"></i>
                                    <span>Referencia de anticipo</span>
                                </div>
                                <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                                    <form>
                                        <div className="container p-0">
                                            <div className="row ">
                                                <div className="col-md-3">
                                                <div className="border-text-menu-title">
                                                    <span className="text-subtitle" >Pago</span>
                                                </div>
                                                </div>
                                                <div className="col-md-9 pt-5 pb-2">
                                                <div className="row">
                                                    <div className="col-md-7 mt-2 mb-2">
                                                        <TextField
                                                            select
                                                            required
                                                            id="an8"
                                                            name="an8"
                                                            label={customers.isLoading ? <div className="fa-1x"> <i className="fas fa-spinner fa-spin"></i></div> : "Num. cliente" }
                                                            variant="outlined"
                                                            size="small" 
                                                            disabled={customers.isDisabled || customers.isLoading}
                                                            fullWidth
                                                            defaultValue={location.state?.customer ? location.state?.customer : ''}
                                                            {...register('an8')}
                                                            error={!!errors.an8}
                                                            onBlur={onCustomerChange}
                                                            >
                                                                <MenuItem value="">Seleccionar cliente</MenuItem>
                                                            {customers.data.map(({noCustomer, name}) => (
                                                                <MenuItem key={noCustomer} value={noCustomer}>
                                                                {noCustomer} - {name}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                        <Typography variant="inherit" color="error">
                                                            {errors?.an8?.message}
                                                        </Typography>
                                                    </div>
                                                    <div className="col-md-7 mt-2 mb-2 d-flex flex-row align-self-center">
                                                    <TextField
                                                        className=''
                                                        select
                                                        required
                                                        id="banco"
                                                        name="banco"
                                                        label={isDisabled || isLoadingConceptsData || cashPayment.isLoading || pendingPayment.isLoading  ? 
                                                            <div className="fa-1x">
                                                            <i className="fas fa-spinner fa-spin"></i>
                                                            </div> : "Banco"}
                                                        variant="outlined"
                                                        size="small"
                                                        disabled={isDisabled || isLoadingConceptsData || cashPayment.isLoading || pendingPayment.isLoading || !getValues().an8 || isLoadingCanPay }
                                                        fullWidth
                                                        {...register('banco')}
                                                        error={!!errors.banco}
                                                        helperText={errors.banco ? errors.banco.message : ''}
                                                        defaultValue={""}
                                                        value={watch("banco")|| ""}
                                                        >
                                                        <MenuItem value="">Seleccione su banco {}</MenuItem>
                                                        {bancos.map((banco) => {
                                                            if(banco === "Bajio" && !userCanPayWithBank) return null; // Si el banco es Bajio y el usuario no tiene acceso, no mostrarlo
                                                            return(
                                                            <MenuItem key={banco} value={banco}>
                                                            <div className='w-25 h-25'>
                                                                <span>{banco}</span>  
                                                            </div>
                                                            </MenuItem>
                                                        )})}
                                                        </TextField>
                                                        
                                                </div>
                                                    <div className="col-md-7 mt-2 mb-2">
                                                    <TextField
                                                        select
                                                        required
                                                        id="concept"
                                                        name="concept"
                                                        label={ isLoadingConceptsData || cashPayment.isLoading || pendingPayment.isLoading ? <div className="fa-1x"> <i className="fas fa-spinner fa-spin"></i></div> : "Seleccionar concepto"}
                                                        variant="outlined"
                                                        size="small" 
                                                        fullWidth
                                                        {...register('concept', { required: true })}
                                                        defaultValue=""
                                                        error={!!errors?.concept}
                                                        disabled = {isDisabled || isLoadingConceptsData || cashPayment.isLoading || pendingPayment.isLoading  }
                                                        onChange={handleChange}
                                                        value={watch("concept") || ""}
                                                        >
                                                            <MenuItem value="">Seleccionar concepto</MenuItem>
                                                        {contentConcepts.map((option) => (
                                                            <MenuItem disabled={cashPayment.isLoading || pendingPayment.isLoading } key={option} value={option}>
                                                            {option}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                    <Typography variant="inherit" color="error">
                                                        {errors?.concept?.message}
                                                    </Typography>
                                                    </div>
                                                    <div className="col-md-7 mt-2 mb-2">
                                                    <TextField
                                                        required
                                                        id="amount"
                                                        name="amount"
                                                        label="Importe"
                                                        fullWidth
                                                        size="small"
                                                        variant="outlined"
                                                        {...register('amount')}
                                                        error={!!errors?.amount}
                                                        disabled = { isDisabled }
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                          }}
                                                    />
                                                    <Typography variant="inherit" color="error">
                                                            {errors?.amount?.message}
                                                    </Typography>
                                                    </div>
                                                    <div className="col-md-12 mt-2 mb-2">
                                                    <TextField
                                                        required
                                                        className="w-100"
                                                        id="comment"
                                                        name="comment"
                                                        label="Comentario"
                                                        type="text"
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        multiline
                                                        rows={4}
                                                        {...register('comment')}
                                                        error={!!errors?.comment}
                                                        disabled = { isDisabled }
                                                    />
                                                    <Typography variant="inherit" color="error">
                                                        {errors.comment?.message}
                                                    </Typography>
                                                    </div>
                                                </div> 
                                                </div>
                                            </div>
                                            <div className="d-flex flex-row-reverse ">
                                                <div className="col-md-9 d-flex flex-row-reverse border-button-actions mt-2 pt-2">
                                                <Tooltip title={tooltipMessage } placement="top-start" arrow>
                                                    <div>
                                                        <button  
                                                        className="btn custom-btn pt-2 pb-2 ps-3 pe-3" 
                                                        onClick={ handleSubmit(startServicePaiment) }
                                                        //onClick={ handleSubmit(onSubmit) }
                                                        disabled={ isLoadingStartAdvancePayment || isDisabled || (!pendingPayment.status && selectConcept ==="Anticipo") || (!cashPayment.status && selectConcept ==="Contado") }
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <span>Procesar pago</span>
                                                                <span className="pt-1 ps-2">
                                                                {
                                                                    isLoadingStartAdvancePayment
                                                                    ? <i className="fas fa-spinner fa-spin"></i>
                                                                    : <i className="fas fa-angle-right"></i>
                                                                }
                                                                </span>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </Tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <PaymentModal storedClass = {storedClass} formData={dataStartPayment} setOpenModalPayment={setOpenModalPayment} openModalPayment={openModalPayment} path="/advance" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
};